@import "../common-input";


.slider-container {
  display: flex;
  align-items: center;
  user-select: none;
  gap: v(--spacing-05);

  .slider-wrapper {
    display: flex;
    align-items: center;
    user-select: none;
    flex: 1;
    gap: 1rem;

    .slider {
      position: relative;
      width: 100%;
      min-width: 10rem;
      padding: v(--spacing-05) 0;
      cursor: pointer;

      .slider__thumb {
        position: absolute;
        top: 50%;
        left: 0;
        width: 1rem;
        height: 1rem;
        background-color: v(--border-inverse);
        border-radius: 50%;
        transform: translateY(-50%);
        transition: transform 0.2s ease-in-out;
        z-index: 1;

        &:hover {
          transform: translateY(-50%) scale(1.2);
        }
      }

      .slider__track {
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        height: 0.125rem;
        background-color: var(--layer-accent);
        transform: translateY(-50%);
      }

      .slider__track--filled {
        pointer-events: none;
        position: absolute;
        top: 50%;
        left: 0;
        width: 20%;
        height: 0.125rem;
        background-color: v(--border-inverse);
        transform: translateY(-50%);
      }

      &.has-focus {
        .slider__thumb {
          background-color: v(--color-primary);
          transform: translateY(-50%) scale(1.2);
        }

        .slider__track--filled {
          background-color: v(--color-primary);
        }
      }

    }
  }

  .slide-input {
    .input {
      margin: 0;
      width: 5rem;
    }
  }
}
